import { useState } from "react";
import {
  Autocomplete,
  TextField,
  FormControl,
  useTheme,
} from "@mui/material";

export default function CategorizedSelect(props) {
  const {
    // OnClose needs to set the values back to an empty array
    assets = [],
    noOptionsText = "No options",
    onChange = () => { },
    onClose = () => { },
    onItemClick = () => { },
    size = "small",
    value = "",
  } = props

  const theme = useTheme();
  const { palette = {} } = theme;
  const { background = {}, mode } = palette;
  const isDark = mode === "dark";
  const bgPaper = background?.paper || (isDark ? "#032d42" : "#ffffff");
  const [open, setOpen] = useState(false);

  const selectOptions =
    assets.map((item, idx) => {
      const {
        assetId,
        facilityId,
        name,
        tag,
        type,
        zoneId,
      } = item || {};
      const label = type === "Assets" ? tag : name || "Unnamed";

      // Use assetId, facilityId, zoneId, or fallback to idx for uniqueness
      const uniqueId = assetId || zoneId || facilityId || idx;

      return {
        id: uniqueId,
        label,
        originalItem: item,
        type: type,

        // Suggestion options do not have a uniqueId so we default to the idx
        value: uniqueId,
      };
    }) || [];

  return (
    <FormControl sx={{ width: "100%" }} variant="filled">
      {/* https://mui.com/material-ui/react-autocomplete/#search-as-you-type */}
      <Autocomplete
        autoComplete
        disableCloseOnSelect
        filterOptions={(x) => x}
        filterSelectedOptions
        fullWidth
        getOptionLabel={(option) => option?.label}
        groupBy={option => option.type}
        id="inventory-ea-txtselect-binlocation"
        includeInputInList
        inputValue={value}
        multiple={false}

        // If there is a value and no options. Then that means there are no options to show. If there is no value or no options. Then the user hasnt searched yet.
        noOptionsText={noOptionsText}
        open={open}
        // This handles when the user selects an option.
        onChange={(event, newValue) => {
          onItemClick(event, newValue);
          setOpen(false); // <-- This closes the dropdown after selection
        }}
        onClose={() => {
          onClose();
          setOpen(false);
        }}

        // This handles when the user types.
        onInputChange={(event, newInputValue, reason) => {

          // reason was inserted here to handle this firing off when redux started controlling state.
          if (reason === "input") {
            // Trigger onChange
            onChange(newInputValue);
          }
        }}
        onOpen={() => setOpen(true)}
        options={selectOptions}
        renderInput={(params) => (
          <TextField
            {...params}
            fullWidth
            label="Search for an asset..."
            onKeyDown={(e) => {
              // When Enter is pressed and the search value is not empty,
              // fire onItemClick with the first matching option (or first option in the list)
              if (
                e.key === "Enter" &&
                value &&
                value.length > 0
              ) {
                onItemClick(e, { label: value, type: "Enter Key", id: value });
                setOpen(false);
              }
            }}
          />
        )}
        renderOption={(props, option) => (
          <li {...props} key={option.id}>
            {option.label}
          </li>
        )}
        size={size}
        sx={{
          backgroundColor: bgPaper,
          "& .MuiOutlinedInput-root": {
            backgroundColor: bgPaper,
          },
        }}
      />
    </FormControl>
  )
}